<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入下单平台或下单手机号" v-model="searchVal" @change="getData" style="width:240px;margin-right:30px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-radio-group v-model="audit_status" @change="change">
                <el-radio label="" border>全部</el-radio>
                <el-radio :label="0" border>审核中</el-radio>
                <el-radio :label="1" border>已通过</el-radio>
                <el-radio :label="-1" border>未通过</el-radio>
            </el-radio-group>
        </div>
        <el-card >
            <el-table :data="tableData"  height="580">
                <el-table-column prop="user.username" label="用户账号" align="center"></el-table-column>
                <el-table-column prop="" label="用户手机" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.user.phone ? scope.row.user.phone : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="用户邮箱" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.user.email ? scope.row.user.email : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="audit_status" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.audit_status == 0" >
                            审核中
                        </el-link>
                        <el-link  type="success"  v-if="scope.row.audit_status == 1">
                            已通过
                        </el-link>
                        <el-link type="danger" v-if="scope.row.audit_status == -1" >
                            已拒绝
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="apply_channel" label="下单平台" align="center"></el-table-column>
                <el-table-column prop="apply_phone" label="下单手机号" align="center"></el-table-column>
                <el-table-column prop="audit_time" label="审核时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="250">
                    <template slot-scope="scope">
                        <el-button plain size="mini"  @click="handleShow(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" title="详情"  width="900px" align="center">
            <el-card class="m-bottom-4">
                <el-row :gutter="20" class="line-item">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="5" class="item-label">下单平台</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.apply_channel" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="5" class="item-label">下单手机号</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.apply_phone" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="line-item">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="5" class="item-label">下单金额</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.apply_amount" readonly>
                                    <span slot="prefix">C$</span>
                                </el-input>
                            </el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="5" class="item-label">返利金额</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.rebate_amount" readonly>
                                    <span slot="prefix">C$</span>
                                </el-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-row :gutter="20" class="line-item">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="5" class="item-label">返利名称</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.rebate.title" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="5" class="item-label">返利比例</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.rebate.rebate_scale" readonly>
                                    <span slot="suffix">%</span>
                                </el-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="line-item">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="5" class="item-label">领取时间</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.receive_time" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12">
                        <el-row >
                            <el-col :span="5" class="item-label">过期时间</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.expire_time" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-row :gutter="20" class="line-item">
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="5" class="item-label">审核状态</el-col>
                            <el-col :span="19" class="item-label">
                                <el-link type="primary" v-if="detail.audit_status == 0" style="font-size:20px">
                                    审核中
                                </el-link>
                                <el-link  type="success"  v-if="detail.audit_status == 1" style="font-size:20px">
                                    已通过
                                </el-link>
                                <el-link type="danger" v-if="detail.audit_status == -1" style="font-size:20px">
                                    已拒绝
                                </el-link>
                            </el-col>
                        </el-row>
                    </el-col >
                    <el-col :span="12" v-if="detail.audit_status == -1">
                        <el-row >
                            <el-col :span="5" class="item-label">拒绝理由</el-col>
                            <el-col :span="19" class="item-label">
                                <el-input  v-model="detail.refuse_reason" readonly></el-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card v-if="detail.audit_status == 0">
                <el-row type="flex" class="line-item" justify="center">
                    <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="danger" plain @click="handleBtn(-1)" style="width:120px">拒绝审核</el-button></el-col>
                    <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">关闭</el-button></el-col>
                    <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="success" plain @click="handleBtn(1)" style="width:120px">通过审核</el-button></el-col>
                </el-row>
            </el-card>
        </el-dialog>
        <el-dialog width="600px"  title="拒绝原因" :visible.sync="innerVisible" align="center" append-to-body>
            <div class="refuse-reasons">
                <el-input v-model="refuse_reason" placeholder="请输入拒绝原因"></el-input>
            </div>
            <el-row style="margin-top:20px;text-align:right"><el-button type="primary" style="width:120px;" @click="refuse()">确定</el-button></el-row>
        </el-dialog>
    </section>
</template>
<script>
import { audit_list, audit_put } from '@/api/market.js'
export default {
    data() {
        return {
            searchVal: '',
            audit_status: '',
            tableData:[],
            table_load:false,
            total:0,
            page: 1,
            size: 0,
            dialog:false,    // 控制显示 添加修改弹窗
            disabled: false,
            innerVisible: false, // 拒绝弹窗
            refuse_reason: '',
            detail: {rebate:''}
        }
    },
    methods: {
        getData() {
            let params = {
                page: this.page,
                audit_status: this.audit_status
            }
            if(this.searchVal != '') {
                params.keywords = this.searchVal
            }
            audit_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                    this.size = 0
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        change() {
            this.page = 1
            this.getData()
        },
        handleShow(row) {
            this.detail = row
            this.dialog = true
        },
        handleBtn(e) {
            if(e == -1) {
                this.innerVisible = true
            } else {
                let params = {
                    audit_status: 1
                }
                audit_put(this.detail.id, params).then(res => {
                    if(res) {
                        this.$message({type:"success",message:res.msg})
                        this.dialog = false
                        this.getData()
                    }
                })
            }
        },
        refuse() {
            if(this.refuse_reason == '') {
                return this.$message({type:'warning',message:'请输入拒绝理由'})
            }
            let params = {
                audit_status: -1,
                refuse_reason: this.refuse_reason
            }
            audit_put(this.detail.id, params).then(res => {
                if(res) {
                    this.$message({type:"success",message:res.msg})
                    this.dialog = false
                    this.innerVisible = false
                    this.getData()
                }
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
        text-align: left;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
    /deep/ .el-dialog__body {
        text-align: left
    }
    /deep/ .el-radio {
        margin-right: 10px;
    }
}
</style>
